import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ToastEnum } from '../enums/enum';
import { LogoutRedirectService } from '../services/logout-redirect.service';
import { ToastService } from '../services/toast.service';

@Injectable()
export class LoggerInterceptor implements HttpInterceptor {
  constructor(
    private readonly toastService: ToastService,
    private readonly logoutRedirectService: LogoutRedirectService,
  ) {}

  intercept(req: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('/assets/i18n/')) {
      return handler.handle(req);
    }

    if (req.headers.has('Skip-Auth')) {
      const newHeaders = req.headers.delete('Skip-Auth');
      const cloned = req.clone({ headers: newHeaders });
      return handler.handle(cloned);
    }

    if (localStorage.getItem('token')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
    }

    return handler.handle(req).pipe(
      // tap((response: any) => {
      //   if (
      //     ((req.method === 'POST' && response.status === 201) ||
      //       (req.method === 'DELETE' && response.status === 200)) &&
      //     response instanceof HttpResponse
      //   ) {
      //     this.toastService.add(ToastEnum.success, '');
      //   }
      // }),

      catchError((err: HttpErrorResponse) => {
        if (err?.status === 401) {
          this.logoutRedirectService.logoutAndRedirect();
          return throwError(() => err);
        }
        const msg = err?.error?.message ? `error.${err.error.message}` : 'error.unknown';
        this.toastService.add(ToastEnum.error, msg);
        return throwError(() => err);
      }),
    );
  }
}
